import React, { ComponentPropsWithoutRef, ElementType } from 'react';
import classnames from 'classnames';

import Input from '../input/Input';

import './AutoWidthInput.scss';

export interface AutoWidthInput extends ComponentPropsWithoutRef<ElementType> {
  className?: string;
  value?: string;
  placeholder?: string;
}

const AutoWidthInput = ({
  className,
  value,
  placeholder,
  ...props
}: AutoWidthInput) => {
  return (
    <div className={classnames('auto-width-input', className)}>
      <span className="auto-width-input__space-sizer">
        {value || placeholder}
      </span>
      <Input
        className="auto-width-input__input"
        value={value}
        placeholder={placeholder}
        {...props}
      />
    </div>
  );
};

export default AutoWidthInput;
